import { useQuery } from '@tanstack/react-query';
import { getMcpCatalog } from '../../api/mcp-catalog.api';
import { ADMIN_QUERY_KEYS } from '../../api';

export const useGetCatalogMcps = () => {
  return useQuery({
    queryKey: ADMIN_QUERY_KEYS.mcpCatalog.available,
    queryFn: getMcpCatalog,
    staleTime: 5 * 60 * 1000,
  });
};
